// mqttWs.js

const websocket = require("websocket-stream")

function buildBuilder(_, opts) {
  return websocket(opts.url, ["mqttv3.1"], opts.websocketOptions)
}

module.exports = buildBuilder
